"use client"

import React, { useState } from "react"
import { Search } from "lucide-react"
import { extractLogs, downloadText, highlightSearch } from "../utils/logsHelpers"
import { formatDateTime } from "../utils/runsHelpers"

export function LogsModal({ open, run, onClose, datasetById }) {
  const [logsQuery, setLogsQuery] = useState("")

  if (!open || !run) return null

  const datasetLabel = datasetById[run._dataset]?.label || run._dataset || "Run"

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      onClick={onClose}
    >
      <div className="absolute inset-0 bg-black/60" />
      <div
        className="relative w-[95vw] max-w-4xl max-h-[85vh] bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 shadow-xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 dark:border-gray-700">
          <div className="min-w-0">
            <div className="font-semibold text-gray-900 dark:text-gray-100 truncate">
              Logs • {datasetLabel}
            </div>
            <div className="text-xs text-gray-500 dark:text-gray-400">
              {run.id} • {formatDateTime(run.ts)}
            </div>
          </div>
          <div className="flex items-center gap-2">
            <div className="relative">
              <Search className="h-4 w-4 absolute left-2 top-2.5 text-gray-400 dark:text-gray-400" />
              <input
                value={logsQuery}
                onChange={(e) => setLogsQuery(e.target.value)}
                placeholder="Find in logs…"
                className="h-9 pl-8 pr-2 border rounded bg-white text-gray-900 min-w-[220px] border-gray-300 placeholder-gray-400
                           dark:bg-gray-800 dark:text-gray-100 dark:border-gray-700 dark:placeholder-gray-400"
              />
            </div>
            <button
              onClick={() => {
                const text = extractLogs(run)
                navigator.clipboard?.writeText(text).catch(() => {})
              }}
              className="h-9 px-3 rounded-md bg-gray-100 text-gray-900 hover:bg-gray-200
                         dark:bg-gray-700 dark:text-gray-100 dark:hover:bg-gray-600"
            >
              Copy
            </button>
            <button
              onClick={() =>
                downloadText(`${run.id || "run"}_logs.txt`, extractLogs(run))
              }
              className="h-9 px-3 rounded-md bg-gray-100 text-gray-900 hover:bg-gray-200
                         dark:bg-gray-700 dark:text-gray-100 dark:hover:bg-gray-600"
            >
              Download
            </button>
            <button
              onClick={onClose}
              className="h-9 px-3 rounded-md bg-blue-600 text-white hover:bg-blue-700"
            >
              Close
            </button>
          </div>
        </div>

        <div className="p-0">
          <pre
            className="m-0 p-4 overflow-auto text-sm leading-6 whitespace-pre-wrap font-mono
                       bg-white text-gray-900
                       dark:bg-gray-900 dark:text-gray-100"
          >
            {highlightSearch(extractLogs(run), logsQuery)}
          </pre>
        </div>
      </div>
    </div>
  )
}
